import React from "react";
import LegalPage from "./LegalPage";

export default function PrivacidadPage() {
  return (
    <LegalPage
      title="Política de Privacidad"
      subtitle="Política de Privacidad · Yarima Rodriguez"
      lastUpdated="15 de diciembre de 2025"
    >
      <p>Esta Política de Privacidad describe Nuestras políticas y procedimientos sobre la recopilación, uso y divulgación de Tu información cuando usas el Servicio y te informa sobre Tus derechos de privacidad y cómo la ley te protege.</p>
      <p>Usamos Tus datos Personales para proporcionar y mejorar el Servicio. Al usar el Servicio, aceptas la recopilación y el uso de información de acuerdo con esta Política de Privacidad.</p>

      <h2>Interpretación y Definiciones</h2>
      <h3>Interpretación</h3>
      <p>Las palabras cuyas letras iniciales están en mayúscula tienen significados definidos bajo las siguientes condiciones. Las siguientes definiciones tendrán el mismo significado independientemente de si aparecen en singular o en plural.</p>

      <h3>Definiciones</h3>
      <p>Para los propósitos de esta Política de Privacidad:</p>
      <ul>
        <li><strong>Cuenta</strong> significa una cuenta única creada para Ti para acceder a nuestro Servicio o partes de nuestro Servicio.</li>
        <li><strong>Afiliado</strong> significa una entidad que controla, es controlada por, o está bajo control común con una parte, donde "control" significa propiedad del 50% o más de las acciones, intereses de capital u otros valores con derecho a voto para la elección de directores u otra autoridad de gestión.</li>
        <li><strong>Compañía</strong> (referida como "la Compañía", "Nosotros", "Nos" o "Nuestro" en este Acuerdo) se refiere a Yarima Rodriguez Valenciano, Via Vittorio Alfieri 18 San Benedetto del Tronto (AP), Italia.</li>
        <li><strong>Cookies</strong> son pequeños archivos que se colocan en Tu computadora, dispositivo móvil o cualquier otro dispositivo por un sitio web, que contienen los detalles de Tu historial de navegación en ese sitio web entre sus muchos usos.</li>
        <li><strong>País</strong> se refiere a: Italia</li>
        <li><strong>Dispositivo</strong> significa cualquier dispositivo que pueda acceder al Servicio como una computadora, un teléfono celular o una tableta digital.</li>
        <li><strong>Datos Personales</strong> es cualquier información que se relaciona con un individuo identificado o identificable.</li>
        <li><strong>Servicio</strong> se refiere al Sitio Web y a las clases y cursos de baile online.</li>
        <li><strong>Proveedor de Servicios</strong> significa cualquier persona física o jurídica que procesa los datos en nombre de la Compañía.</li>
        <li><strong>Datos de Uso</strong> se refiere a datos recopilados automáticamente, ya sea generados por el uso del Servicio o de la propia infraestructura del Servicio.</li>
        <li><strong>Sitio Web</strong> se refiere a Yarima Rodriguez, accesible desde <a href="https://www.yarimarodriguez.com" target="_blank" rel="noreferrer">https://www.yarimarodriguez.com</a></li>
        <li><strong>Tú</strong> significa el individuo que accede o usa el Servicio, o la empresa u otra entidad legal en nombre de la cual dicho individuo está accediendo o usando el Servicio, según corresponda.</li>
      </ul>

      <h2>Responsable del Tratamiento y Contacto</h2>
      <p><strong>Responsable del Tratamiento:</strong> Yarima Rodriguez Valenciano</p>
      <p>Via Vittorio Alfieri 18<br />San Benedetto del Tronto (AP), Italia</p>
      <p>Email: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></p>
      <p>Tiempo de respuesta: 30 días hábiles</p>

      <h2>Recopilación y Uso de Tus Datos Personales</h2>
      <h3>Tipos de Datos Recopilados</h3>
      <h3>Datos Personales</h3>
      <p>Mientras usas Nuestro Servicio, podemos pedirte que Nos proporciones cierta información de identificación personal que puede ser utilizada para contactarte o identificarte. La información de identificación personal puede incluir, pero no está limitada a:</p>
      <ul>
        <li>Dirección de correo electrónico</li>
        <li>Nombre y apellido</li>
        <li>Número de teléfono</li>
        <li>Dirección, Estado, Provincia, Código postal, Ciudad</li>
        <li>Datos de Uso</li>
      </ul>

      <h3>Datos de Uso</h3>
      <p>Los Datos de Uso se recopilan automáticamente cuando se utiliza el Servicio.</p>
      <p>Los Datos de Uso pueden incluir información como la dirección de Protocolo de Internet de Tu Dispositivo (por ejemplo, dirección IP), tipo de navegador, versión del navegador, las páginas de nuestro Servicio que visitas, la hora y fecha de Tu visita, el tiempo dedicado a esas páginas, identificadores únicos de dispositivos y otros datos de diagnóstico.</p>
      <p>Cuando accedes al Servicio a través de un dispositivo móvil, podemos recopilar cierta información automáticamente, incluyendo el tipo de dispositivo móvil que usas, el ID único de Tu dispositivo móvil, la dirección IP de Tu dispositivo móvil, Tu sistema operativo móvil, el tipo de navegador de Internet móvil que usas, identificadores únicos de dispositivos y otros datos de diagnóstico.</p>

      <h3>Categorías Especiales de Datos</h3>
      <p>NO recopilamos ni procesamos categorías especiales de datos personales (datos sensibles) como:</p>
      <ul>
        <li>Origen étnico o racial</li>
        <li>Opiniones políticas</li>
        <li>Creencias religiosas o filosóficas</li>
        <li>Afiliación sindical</li>
        <li>Datos genéticos o biométricos</li>
        <li>Datos de salud</li>
        <li>Orientación sexual</li>
      </ul>
      <p>Si proporcionas voluntariamente esta información, será eliminada inmediatamente.</p>

      <h3>Tecnologías de Seguimiento y Cookies</h3>
      <p>Usamos Cookies y tecnologías de seguimiento similares para rastrear la actividad en Nuestro Servicio y almacenar cierta información. Las tecnologías que usamos pueden incluir:</p>
      <p><strong>Cookies o Cookies del Navegador:</strong> Una cookie es un pequeño archivo colocado en Tu Dispositivo. Puedes indicar a Tu navegador que rechace todas las Cookies o que indique cuando se está enviando una Cookie.</p>
      <p><strong>Balizas Web:</strong> Ciertas secciones de nuestro Servicio y nuestros correos electrónicos pueden contener pequeños archivos electrónicos conocidos como balizas web.</p>
      <p>Usamos tanto Cookies de Sesión como Persistentes para los siguientes propósitos:</p>
      <h3>Cookies Necesarias / Esenciales</h3>
      <ul>
        <li>Tipo: Cookies de Sesión</li>
        <li>Administradas por: Nosotros</li>
        <li>Propósito: Esenciales para proporcionarte servicios y funciones del Sitio Web</li>
      </ul>
      <h3>Cookies de Aceptación de Política / Aviso de Cookies</h3>
      <ul>
        <li>Tipo: Cookies Persistentes (máximo 12 meses)</li>
        <li>Administradas por: Nosotros</li>
        <li>Propósito: Identifican si los usuarios han aceptado el uso de cookies</li>
      </ul>
      <h3>Cookies de Funcionalidad</h3>
      <ul>
        <li>Tipo: Cookies Persistentes (máximo 12 meses)</li>
        <li>Administradas por: Nosotros</li>
        <li>Propósito: Recordar tus preferencias y proporcionar una experiencia personalizada</li>
      </ul>

      <h2>Uso de Tus Datos Personales</h2>
      <p>La Compañía puede usar los Datos Personales para los siguientes propósitos:</p>
      <ul>
        <li><strong>Para proporcionar y mantener nuestro Servicio</strong>, incluyendo monitorear el uso de nuestro Servicio</li>
        <li><strong>Para gestionar Tu Cuenta:</strong> gestionar Tu registro como usuario del Servicio</li>
        <li><strong>Para el cumplimiento de un contrato:</strong> desarrollo, cumplimiento y realización del contrato de servicios educativos</li>
        <li><strong>Para contactarte:</strong> Por correo electrónico, llamadas telefónicas, SMS u otras formas de comunicación electrónica</li>
        <li><strong>Para proporcionarte</strong> noticias, ofertas especiales e información sobre nuestros cursos y clases</li>
        <li><strong>Para gestionar Tus solicitudes:</strong> Atender y gestionar Tus solicitudes</li>
        <li><strong>Para transferencias comerciales:</strong> En caso de fusión, venta o transferencia de activos</li>
        <li><strong>Para otros propósitos:</strong> Análisis de datos, mejora del servicio, tendencias de uso</li>
      </ul>

      <h2>Base Legal para el Procesamiento de Datos Personales bajo el GDPR</h2>
      <p>Procesamos tus Datos Personales bajo las siguientes bases legales:</p>
      <ul>
        <li><strong>Consentimiento:</strong> Has dado tu consentimiento para procesar Datos Personales para uno o más propósitos específicos</li>
        <li><strong>Ejecución de Contrato:</strong> El procesamiento es necesario para la ejecución de un contrato del cual eres parte</li>
        <li><strong>Obligaciones Legales:</strong> El procesamiento es necesario para cumplir con obligaciones legales</li>
        <li><strong>Intereses Legítimos:</strong> El procesamiento es necesario para nuestros intereses legítimos (prestación de servicios educativos online)</li>
      </ul>
      <p>Puedes retirar tu consentimiento en cualquier momento contactándonos a: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></p>

      <h3>Consentimiento y Legitimación</h3>
      <ul>
        <li>El consentimiento debe ser libre, específico, informado e inequívoco</li>
        <li>Para menores entre 16-21 años: Se requiere consentimiento parental verificable</li>
        <li>Puedes retirar tu consentimiento en cualquier momento sin que esto afecte la legalidad del procesamiento previo</li>
        <li>No condicionamos la prestación del servicio al consentimiento para procesamiento no necesario</li>
      </ul>

      <h2>Compartir Tus Datos Personales</h2>
      <h3>Período de Retención de Datos</h3>
      <p>Conservamos tus Datos Personales según los siguientes criterios:</p>
      <ul>
        <li><strong>Datos de cuenta:</strong> Mientras tu cuenta esté activa + 2 años</li>
        <li><strong>Datos de facturación:</strong> 10 años (obligación fiscal en Italia/España)</li>
        <li><strong>Datos de comunicaciones:</strong> 1 año desde el último contacto</li>
        <li><strong>Cookies de sesión:</strong> Se eliminan al cerrar el navegador</li>
        <li><strong>Cookies persistentes:</strong> Máximo 12 meses</li>
      </ul>
      <p>Después de estos períodos, los datos se eliminarán o anonimizarán de forma segura.</p>

      <h3>Transferencias Internacionales de Datos</h3>
      <p>Tus datos pueden ser transferidos y procesados en países fuera del Espacio Económico Europeo (EEE) o tu país de residencia. Cuando esto ocurra, garantizamos que:</p>
      <ul>
        <li>Se aplican Cláusulas Contractuales Estándar aprobadas por la Comisión Europea</li>
        <li>El país receptor cuenta con un nivel adecuado de protección según la normativa aplicable</li>
        <li>Existen salvaguardas apropiadas conforme al Artículo 46 del GDPR</li>
      </ul>
      <p>Tienes derecho a obtener una copia de las salvaguardas implementadas contactándonos.</p>

      <h2>Tus Derechos sobre los Datos Personales</h2>
      <p>Bajo el GDPR y legislación latinoamericana aplicable, tienes los siguientes derechos:</p>
      <h3>Residentes de la Unión Europea:</h3>
      <ul>
        <li><strong>Derecho de Acceso:</strong> Solicitar copia de tus datos personales</li>
        <li><strong>Derecho de Rectificación:</strong> Corregir datos inexactos o incompletos</li>
        <li><strong>Derecho de Supresión ("al olvido"):</strong> Solicitar eliminación de tus datos</li>
        <li><strong>Derecho de Limitación:</strong> Restringir el procesamiento de tus datos</li>
        <li><strong>Derecho de Portabilidad:</strong> Recibir tus datos en formato estructurado</li>
        <li><strong>Derecho de Oposición:</strong> Oponerte al procesamiento de tus datos</li>
        <li><strong>Derecho sobre Decisiones Automatizadas:</strong> No ser sujeto a decisiones basadas únicamente en procesamiento automatizado</li>
      </ul>
      <h3>Residentes de Latinoamérica (Derechos ARCO):</h3>
      <ul>
        <li><strong>Acceso:</strong> Conocer qué datos personales tenemos sobre ti</li>
        <li><strong>Rectificación:</strong> Corregir datos inexactos</li>
        <li><strong>Cancelación:</strong> Solicitar la eliminación de tus datos</li>
        <li><strong>Oposición:</strong> Oponerte al tratamiento de tus datos para fines específicos</li>
      </ul>
      <p>Período de respuesta: Máximo 30 días desde la recepción de tu solicitud. Para ejercer estos derechos, contacta a: <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></p>

      <h2>Divulgación de Tus Datos Personales</h2>
      <h3>Transacciones Comerciales</h3>
      <p>Si la Compañía está involucrada en una fusión, adquisición o venta de activos, Tus Datos Personales pueden ser transferidos. Proporcionaremos aviso antes de que Tus Datos Personales sean transferidos y se conviertan en objeto de una Política de Privacidad diferente.</p>
      <h3>Cumplimiento de la ley</h3>
      <p>Bajo ciertas circunstancias, la Compañía puede estar obligada a divulgar Tus Datos Personales si así lo requiere la ley o en respuesta a solicitudes válidas de las autoridades públicas.</p>
      <h3>Otros requisitos legales</h3>
      <p>La Compañía puede divulgar Tus Datos Personales con la creencia de buena fe de que tal acción es necesaria para:</p>
      <ul>
        <li>Cumplir con una obligación legal</li>
        <li>Proteger y defender los derechos o propiedad de la Compañía</li>
        <li>Prevenir o investigar posibles irregularidades</li>
        <li>Proteger la seguridad personal de los Usuarios</li>
        <li>Proteger contra la responsabilidad legal</li>
      </ul>

      <h2>Seguridad de Tus Datos Personales</h2>
      <p>La seguridad de Tus Datos Personales es importante para Nosotros. Implementamos medidas técnicas y organizativas apropiadas, incluyendo:</p>
      <ul>
        <li>Cifrado de datos</li>
        <li>Acceso restringido a datos personales</li>
        <li>Auditorías regulares de seguridad</li>
        <li>Formación del personal en protección de datos</li>
      </ul>
      <p>Aunque nos esforzamos por usar medios comercialmente razonables para proteger Tus Datos Personales, no podemos garantizar su seguridad absoluta.</p>

      <h3>Notificación de Brechas de Seguridad</h3>
      <p>En caso de una brecha de seguridad que afecte tus Datos Personales:</p>
      <ul>
        <li><strong>Notificación a Autoridades:</strong> Dentro de las 72 horas (GDPR)</li>
        <li><strong>Notificación a Usuarios:</strong> Sin demora indebida si existe alto riesgo para tus derechos y libertades</li>
        <li><strong>Registro de Incidentes:</strong> Mantenemos un registro detallado de todas las brechas de seguridad</li>
      </ul>

      <h2>Privacidad de los Niños</h2>
      <p>Nuestro Servicio está dirigido exclusivamente a adultos mayores de 21 años y no se dirige a nadie menor de 21 años. No recopilamos conscientemente información de identificación personal de nadie menor de 21 años. El uso de nuestras clases y cursos de baile online está destinado únicamente a personas adultas mayores de 21 años.</p>
      <p>Si eres padre o tutor y sabes que Tu hijo menor de 21 años Nos ha proporcionado Datos Personales, por favor contáctanos inmediatamente. Si Nos damos cuenta de que hemos recopilado Datos Personales de alguien menor de 21 años sin verificación de la edad apropiada, tomamos medidas inmediatas para eliminar esa información de Nuestros servidores.</p>
      <p>Dado que nuestras clases y cursos de baile están diseñados específicamente para adultos que buscan formación profesional y desarrollo artístico en danza, no proporcionamos servicios educativos a personas menores de 21 años bajo ninguna circunstancia.</p>

      <h2>Enlaces a Otros Sitios Web</h2>
      <p>Nuestro Servicio puede contener enlaces a otros sitios web que no son operados por Nosotros. Si haces clic en un enlace de terceros, serás dirigido al sitio de ese tercero. Te aconsejamos encarecidamente que revises la Política de Privacidad de cada sitio que visites.</p>
      <p>No tenemos control sobre y no asumimos ninguna responsabilidad por el contenido, las políticas de privacidad o las prácticas de sitios o servicios de terceros.</p>

      <h2>Autoridades de Control y Reclamaciones</h2>
      <p>Tienes derecho a presentar una reclamación ante la autoridad de control de protección de datos:</p>
      <p><strong>Para residentes de la UE/Italia:</strong> Garante per la protezione dei dati personali<br />
        Piazza Venezia 11, 00187 Roma<br />
        Email: <a href="mailto:garante@gpdp.it">garante@gpdp.it</a></p>
      <p><strong>Para residentes de España:</strong> Agencia Española de Protección de Datos (AEPD)<br />
        C/ Jorge Juan, 6, 28001 Madrid<br />
        <a href="http://www.aepd.es" target="_blank" rel="noreferrer">www.aepd.es</a></p>
      <p><strong>Para residentes de Argentina:</strong> Agencia de Acceso a la Información Pública<br />
        Av. Pte. Gral. Julio A. Roca 710, Piso 2<br />
        Ciudad Autónoma de Buenos Aires</p>
      <p><strong>Para residentes de México:</strong> Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales (INAI)<br />
        <a href="http://www.inai.org.mx" target="_blank" rel="noreferrer">www.inai.org.mx</a></p>
      <p><strong>Para residentes de Colombia:</strong> Superintendencia de Industria y Comercio<br />
        <a href="http://www.sic.gov.co" target="_blank" rel="noreferrer">www.sic.gov.co</a></p>

      <h2>Cambios a esta Política de Privacidad</h2>
      <p>Podemos actualizar Nuestra Política de Privacidad de vez en cuando:</p>
      <ul>
        <li><strong>Notificación anticipada:</strong> 30 días antes de cambios sustanciales</li>
        <li><strong>Métodos de notificación:</strong> Email y aviso prominente en el sitio web</li>
        <li><strong>Cambios materiales requieren nuevo consentimiento</strong></li>
        <li><strong>Histórico de versiones disponible bajo solicitud</strong></li>
      </ul>
      <p>Se te recomienda revisar esta Política de Privacidad periódicamente. Los cambios son efectivos cuando se publican en esta página.</p>

      <h2>Contáctanos</h2>
      <p>Si tienes alguna pregunta sobre esta Política de Privacidad, puedes contactarnos:</p>
      <p><strong>Por correo electrónico:</strong> <a href="mailto:contacto@yarimarodriguez.com">contacto@yarimarodriguez.com</a></p>
      <p><strong>Dirección postal:</strong><br />
        Yarima Rodriguez Valenciano<br />
        Via Vittorio Alfieri 18<br />
        San Benedetto del Tronto (AP)<br />
        Italia</p>
    </LegalPage>
  );
}
